import { Box, CircularProgress, DialogContent } from "@mui/material";
import { withErrorBoundary } from "hocs/withErrorBoundary";
import useGlobalContext from "hooks/globalData";
import { useStrictQuery } from "hooks/useStrictQuery";
import MediaLibraryItemUpdateForm from "pages/MediaLibraryPage/MediaLibraryItemUpdateForm";
import { MediaItemSource } from "services/KnowfullyAdminClient";
import { MediaFilterType } from "utils/mediaUtils";

type SkuDeliveryMediaItemUpdateFormProps = {
  source: MediaItemSource;
  mediaFilter: MediaFilterType;
  deliverableId?: string;
  onUpdated: () => void;
  onCancel: () => void;
};

const SkuDeliveryMediaItemUpdateForm = ({
  source,
  mediaFilter,
  deliverableId,
  onUpdated,
  onCancel,
}: SkuDeliveryMediaItemUpdateFormProps) => {
  const { mediaService } = useGlobalContext();
  const { isLoading, data } = useStrictQuery(
    ["media-item", deliverableId],
    () => mediaService.getItem(deliverableId!, source),
    {
      enabled: !!deliverableId,
    }
  );

  return (
    <DialogContent>
      {isLoading && (
        <Box textAlign="center">
          <CircularProgress />
        </Box>
      )}

      {!!data?.data && (
        <MediaLibraryItemUpdateForm
          alternativeTextRequired={true}
          customAlternativeTextLabel="displayText"
          source={source}
          options={[mediaFilter]}
          mediaItem={data?.data}
          onMediaLibraryItemUpdated={onUpdated}
          onCancel={onCancel}
        />
      )}
    </DialogContent>
  );
};

export default withErrorBoundary(SkuDeliveryMediaItemUpdateForm);
